import React from "react";

class Link extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { props } = this;
        let label = props.selected.label ? props.selected.label : props.placeholder;

        if (props.useValue) {
            label = props.selected.value ? props.selected.value : props.placeholder
        }
        
        return (
            <a onClick={props.onTrigger} class={`selectedTrigger ${props.open ? "active" : ""} ${props.classes.trigger}`}>
                <span>{props.renderSelected && props.selected.label ? props.renderSelected(props.selected) : label}</span>
                <i class="material-icons">arrow_drop_down</i>
            </a>
        )
    }
}

export default Link;